import React from "react";
import { Link } from "react-router-dom";
import appConfig from '../config';

import Emoji from "../components/primatives/Emoji";
import Section from "../components/primatives/Section";
import TagButton from "../components/primatives/TagButton";
import SectionHeader from "../components/primatives/SectionHeader";
import ActionButton from "../components/primatives/ActionButton";
import { FiStar, FiArrowRightCircle, FiDisc } from "react-icons/fi";

const { items_for_sale } = appConfig;

class Credits extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadState: props.helpers.loadState(),
    };
  }

  buyItem = (e,product=592932) => {
    // opens paddle checkout
    const { loadState } = this.state;

    e.preventDefault();
    window.Paddle.Checkout.open({
      product,
      passthrough: `{"accountName": "${loadState.account.name}"}`
		});
  }

  render() {
    const { loadState } = this.state;
    const { account } = loadState;

    return (
      <div>
        <Section>
          <SectionHeader>
            <FiStar /> Buy Credits
          </SectionHeader>
          <div className="text-sm">
            Full ownership & control of data. Secured with a top-10
            public blockchain.
          </div>
          {!account.key ? <div className="text-sm mt-2 font-bold text-red-600">
            You must login to make a purchase.
            <div className="mt-1" />
            <Link to="/account"><TagButton>Login to account. <FiArrowRightCircle /></TagButton></Link>
          </div> : null}
        </Section>

        <Section>
          <SectionHeader>
            <span className="font-extrabold"><Emoji type="cpu" /> CPU</span>
          </SectionHeader>
          <div className="text-sm mb-2">
            Receive credits to add, update, or delete your data.{" "}
            <b>You'll receive: 100 <Emoji type="cpu" /></b>
          </div>
          <ActionButton disabled={!Boolean(account.key)} onClick={(e) => this.buyItem(e,items_for_sale.cpu)}><FiDisc style={{color:'white'}} /> Buy: $6 (one time)</ActionButton>
          <div className="text-xs mt-2">
            1 <Emoji type="cpu" /> = 1 data modification. <i>reads are free.</i>
          </div>
        </Section>

        <Section>
          <SectionHeader>
            <span className="font-extrabold"><Emoji type="storage" /> STORAGE</span>
          </SectionHeader>
          <div className="text-sm mb-2">
            Reserve lifetime space on the blockchain for your data.{" "}
            <b>You'll receive: 1000 <Emoji type="storage" /></b>
          </div>
          <ActionButton disabled={!Boolean(account.key)} onClick={(e) => this.buyItem(e,items_for_sale.storage)}><FiDisc style={{color:'white'}} /> Buy: $6 (one time)</ActionButton>
          <div className="text-xs mt-2">1 <Emoji type="storage" /> = 1 byte of storage.</div>
        </Section>

      </div>
    );
  }
}

export default Credits;
